import clsx from 'clsx';
import type { AnalysisStep } from '../hooks/useMenuAnalysis';

const STEPS: { keys: AnalysisStep[]; label: string }[] = [
  { keys: ['upload'], label: 'Upload' },
  { keys: ['extraction', 'review', 'meta-form', 'meta-basics', 'meta-when-where', 'meta-tax', 'meta-service', 'email'], label: 'Analyze' },
  { keys: ['analysis', 'complete'], label: 'Recommendations' }
];

interface Props { current: AnalysisStep }

const StepIndicator = ({ current }: Props) => {
  const currentIndex = Math.max(0, STEPS.findIndex((s) => s.keys.includes(current)));
  const progress = (currentIndex / (STEPS.length - 1)) * 100;
  
  return (
    <div className="mx-auto w-full max-w-4xl">
      <div className="relative">
        <div className="h-1 w-full rounded-full bg-slate-200" />
        <div
          className="absolute inset-y-0 left-0 rounded-full bg-slate-500 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
        <div className="absolute inset-0 flex items-center">
          {STEPS.map((_, i) => {
            const isActive = i === currentIndex;
            const isDone = i < currentIndex;
            const position = (i / (STEPS.length - 1)) * 100;
            return (
              <span
                key={i}
                className={clsx(
                  'absolute h-3.5 w-3.5 rounded-full border-2 bg-white transition-colors duration-200 ease-out -translate-x-1/2',
                  isActive ? 'border-slate-700' : isDone ? 'border-slate-500' : 'border-slate-300'
                )}
                style={{ left: `${position}%` }}
              />
            );
          })}
        </div>
      </div>
      <div className="mt-2 relative">
        {STEPS.map((s, i) => {
          const isActive = i === currentIndex;
          const isDone = i < currentIndex;
          const position = (i / (STEPS.length - 1)) * 100;

          // Alignment classes
          let alignment = "-translate-x-1/2"; // default: centered
          if (i === 0) {
            alignment = "translate-x-0";        // align left edge
          } else if (i === STEPS.length - 1)
          {
            alignment = "-translate-x-full"; // align right edge
          }

          return (
            <span
              key={s.keys[0]}
              className={clsx(
                'absolute text-[11px] leading-4 tracking-wide whitespace-nowrap',
                alignment,
                isActive ? 'text-slate-900 font-medium' : isDone ? 'text-slate-700' : 'text-slate-500'
              )}
              style={{ left: `${position}%` }}
            >
              {s.label}
            </span>
          );
        })}

      </div>
    </div>
  );
};

export default StepIndicator;
